(function($i, $) {
  function ProductVariantSelect(options) {
    this.options = options;
    this.parentObj = options.parentObj;
    this.allSelects = this.parentObj.allSelects;
    this.selectElem = $('<select class="span-12"></select>');
    this.selectElemWrapper = $(
      '<div class="row-fluid lookup-select-container"></div>'
    );
    this.selectId = options.selectId + 1;
    this.dataUrl = options.dataUrl;
    this.currentValue = null;
    this.prevSelectValue = options.prevSelectValue;
    this.typeOfSelect = options.typeOfSelect;
    this.parentObj.selectedProductVariant = this.selectId;
    this.singleOption = false;
    this.selectedOption = null;
    this.years = [];
    this.showYearSelectContainer = $.find('#year-dropdown-feature').length === 1;
    this.enableFind = options.enableFind;
    if (this.typeOfSelect === 'product') {
      this.initProduct();
    } else {
      this.selectElemWrapper = this.showYearSelectContainer ?
          $('<div class="row-fluid lookup-year-container"></div>') :
          $('<div class="row-fluid lookup-year-container hidden"></div>');
      this.renderYearVariant();
    }
  }

  // Prevents a "disabled" select from opening.
  function preventDisabledSelectDropdown(event) {
    if ($(this).attr('aria-disabled') === 'true' && event.key !== 'Tab') {
      event.preventDefault();
    }
  }

  ProductVariantSelect.prototype.initProduct = function() {
    var self = this;

    self.buildProductVariant();

    self.selectElem.on('mousedown keydown', preventDisabledSelectDropdown);

    self.selectElem.on('change', function() {
      self.selectedOption = $('option:selected', this);

      if ($i.clearVin) {
          // Clear the manual VIN search
          $i.clearVin();
      }

      self.currentValue = $(self.selectElem).val();

      // When changing the value select, remove following select if there are any
      if (self.parentObj.selectedProductVariant !== self.selectId) {
        for (var i = self.allSelects.length - 1; i >= 0; --i) {
          if (self.allSelects[i].selectId > self.selectId) {
            self.allSelects[i].selectElemWrapper.remove();
            self.allSelects.splice(i, 1);
          }
        }
      }

      self.allSelects.forEach(function(item) {
        if (item.selectElem.attr('name') === 'productVariantId') {
          item.selectElem.removeAttr('name');
        }
      });

      // If the 'Please choose an option' option is selected, go back and grab the years of the last rendered select
      if (self.currentValue === '#') {
        var lastPvSelectYears;
        for (var j = self.allSelects.length - 2; j >= 1; j--) {
          var pv = self.allSelects[j];
          if (pv.singleOption === false) {
            lastPvSelectYears = pv.years;
            break;
          } else {
            self.renderYearVariant();
          }
        }
        self.renderYearVariant(lastPvSelectYears);
        self.allSelects[self.selectId - 2].selectElem.attr('name', 'productVariantId');
      } else {
        self.renderYearVariant();
        self.selectElem.attr('name', 'productVariantId');
      }

      // If no further selects, create a new product variant
      if (self.currentValue !== '#' && self.selectId > self.allSelects.length - 1) {
        var productVariant = new ProductVariantSelect({
          parentObj: self.parentObj,
          selectId: self.selectId,
          prevSelectValue: self.currentValue,
          typeOfSelect: 'product',
          dataUrl: self.dataUrl,
          enableFind: self.options.enableFind
        });

        self.allSelects.push(productVariant);
      }

      self.enableFind()
    });
  };

  ProductVariantSelect.prototype.buildProductVariant = function() {
    // This function grabs product variant options from api and creates and appends the new select
    var self = this;
    $.getJSON($i.contextPath + self.dataUrl + self.prevSelectValue, function(data) {
      if (data.length) {
        self.typeOfSelect = 'product';
        self.singleOption = data.length === 1;

        if (!self.singleOption) {
          var firstOption = $(
            '<option value="#">' + $i.i18n.get('select.default.option') + '</option>'
          );
          self.selectElem.append(firstOption);
        }
        for (var i = 0; i < data.length; i++) {
          // Append all options from JSON data for select
          var option = $('<option></option>')
            .attr('value', data[i].id)
            .text(data[i].name)
            .attr('dir', 'auto');
          if ($.inArray('LOOKUP_TARGET', data[i].actions) !== -1) {
              option.attr("is-lookup-target", true);
          }
          self.selectElem.append(option);
        }

        self.selectElemWrapper.append(self.selectElem);
        $('.lookup-year-container').before(self.selectElemWrapper);

        if (self.singleOption) {
          // Do not fully disable the select so it is still posted with the form and can be read by screen readers.
          self.selectElem.attr('aria-disabled', true);
          self.currentValue = data[0].id;
          self.allSelects.forEach(function(item) {
            if (item.selectElem.attr('name') === 'productVariantId') {
              item.selectElem.removeAttr('name');
            }
          });
          self.selectElem.attr('name', 'productVariantId');
          var productVariant = new ProductVariantSelect({
              parentObj: self.parentObj,
              selectId: self.selectId,
              prevSelectValue: self.currentValue,
              typeOfSelect: 'product',
              dataUrl: self.dataUrl,
              enableFind: self.options.enableFind
            });
          // As a singleOption is not selected or changed, the event listener defined above will not run, so render the year select now
          self.renderYearVariant();
          self.allSelects.push(productVariant);
        }
      } else {
        $('.lookup-year-container').show();
        // Determine if there is only a single variant available for selection.
        self.parentObj.singleVariant = self.allSelects.every(function(item) { return item.singleOption || item.typeOfSelect !== 'product' || !item.currentValue; });
        if (self.allSelects.every(function(item) { return item.currentValue === null;}) || $(self.parentObj.container).find("option[is-lookup-target]").length === 0) {
          $("#manual-lookup").hide();
          $("#manual-lookup-toggle").hide();
        }
      }
      self.enableFind();
    });
  };

  ProductVariantSelect.prototype.renderYearVariant = function(lastPvSelectYears) {
    // This function renders/rerenders the year select. The argument lastPvSelectYears is passed in
    // when grabbing a year array from an existing/previous product variant.
    var self = this;
    var yearSelect = $('<select class="span-12" name="year"></select>');
    yearSelect.on('mousedown keydown', preventDisabledSelectDropdown);

    if (lastPvSelectYears === undefined && self.currentValue !== 0 && self.dataUrl) {
      $.getJSON(
        $i.contextPath + self.dataUrl + self.currentValue + '/years',
        function(data) {
          self.years = data;
          renderOptionsFromYearData(data);
        }
      ).error(function() {
        createDefaultYearSelect();
      });
    } else if (lastPvSelectYears && lastPvSelectYears.length) {
      renderOptionsFromYearData(lastPvSelectYears);
    } else {
      createDefaultYearSelect();
    }
    if (self.allSelects[0]) {
      var yearContainer = $('.lookup-year-container');
      yearContainer.find('select').remove();
      self.allSelects[0].selectElem = yearSelect;

        yearContainer.append(yearSelect);
    } else {
      // This only runs for the initial render of the Year select
      self.selectElemWrapper.append(yearSelect);
      self.parentObj.container.append(self.selectElemWrapper);
    }

    function createDefaultYearSelect() {
      // Creates a simple, hidden year select.
      var firstOption = $(
        '<option value="#">' + $i.i18n.get('select.a.year') + '</option>'
      );
      firstOption.attr('dir', 'auto');
      yearSelect.append(firstOption);
      yearSelect.hide();
    }

    function renderOptionsFromYearData(yearArr) {
      // Builds the year select options with years it gets from yearArr
      if (yearArr.length === 1) {
        var defaultOption = $('<option></option>')
          .attr('value', yearArr[0])
          .text(yearArr[0])
          .attr('dir', 'auto');
        yearSelect.append(defaultOption);
        yearSelect.attr('aria-disabled', true);
      }
      else {
        var firstOption = $('<option></option>')
          .attr('value', '#')
          .text($i.i18n.get('select.a.year'))
          .attr('dir', 'auto');
        yearSelect.append(firstOption);

        $.each(yearArr, function(index, year) {
          var option = $('<option></option>')
            .attr('value', year)
            .attr('dir', 'auto')
            .text(year);
          yearSelect.append(option);
        });
      }
    }
  };

  // Creates the product lookup container
  function ProductLookup(options) {
    this.container = $(options.container);
    this.allSelects = [];
    this.submitBtn = null;
    this.selectedProductVariant = null;
    this.options = options;
    this.vinInput = $(options.vinInput);
    this.singleVariant = false;

    this.init();

    this.vinInput.on('input', this.watchVin.bind(this));
  }

  ProductLookup.prototype.init = function() {
    // Retrieves the submit button and its wrapper from the page
    this.submitBtn = $('.lookup-button');
    this.submitBtn.addClass('disabled').attr('disabled', true);
    this.container.empty();

    // Initializes the year select
    var yearVariant = new ProductVariantSelect({
      parentObj: this,
      selectId: 0,
      prevSelectValue: 0,
      typeOfSelect: 'year',
      enableFind: this.enableFind.bind(this)
    });

    this.allSelects.unshift(yearVariant);

    // Initializes the root product variant
    var productVariant = new ProductVariantSelect({
      dataUrl: this.options.dataUrl,
      parentObj: this,
      selectId: 1,
      prevSelectValue: 0,
      typeOfSelect: 'product',
      enableFind: this.enableFind.bind(this)
    });
    this.vinInput.on('input', this.enableFind.bind(this));
    this.allSelects.push(productVariant);
  };

  /**
   * Central function that aims to manage the state of the find button.
   * This function should be bound to ProductLookup and all ProductVariantSelect items so that it can maintain visibility over the state
   * of the lookup form in it's entirety.
   */
  ProductLookup.prototype.enableFind = function () {
    //find button should always be shown if there is a single-variant hierarchy in place, regardless of VIN input.
    if (this.singleVariant && $(this.container).find("option[is-lookup-target]").length) {
      this.submitBtn.removeClass('disabled').attr('disabled', false);
      return;
    }
    //if there is input in the VIN field then the find button should be enabled regardless of length or format to support serial lookup.
    var isDisabled = this.vinInput.val().length === 0;
    var showYears = false;
    if (isDisabled) {
      //Reverse iterate allSelects to find the most specific selected variant that has 'LOOKUP_TARGET' action target.
      //If there is one present then the find button should be enabled and the year drop down should be shown.
      for (var i = this.allSelects.length - 1; i >= 0; i--) {
        var selectAtOffset = this.allSelects[i];
        if (selectAtOffset.selectElem.find('option:selected').attr('is-lookup-target')) {
          showYears = true;
          isDisabled = false;
          break; //stop when the first match is found
        }
      }
    }
    this.submitBtn.toggleClass('disabled', isDisabled).attr('disabled', isDisabled);
    //At this point, showYears is true if the dropdowns have 1 or more selected items in that are look up targets.
    //Therefore, ensure the year dropdown is shown.
    $('.lookup-year-container').toggle(showYears);
  }

  // Bind events to the vin input passed in from initialisation in JSP
  ProductLookup.prototype.watchVin = function() {
    // Indicate the input is valid if 17 characters have been entered.
    if (this.vinInput.val().length === 17) {
        this.vinInput.addClass('valid');
    } else {
        this.vinInput.removeClass('valid');
    }
  };

  $i.productLookup = function() {
    var options = arguments[0];
    return new ProductLookup(options);
  };

  $('#manual-lookup-toggle').on('click', function() {
    $(this).hide();
    $('#manual-lookup').fadeIn();
  });

  $('#favourite-vin-content-div > li:gt(3)').hide();
  $('#favourite-lookup-last-li').click(function(event) {
    event.stopPropagation();
    $('#favourite-vin-content-div > li:gt(3)').show();
    $('#favourite-lookup-last-li').css('display', 'none');
  });

  $('#recent-vin-content-div > li:gt(3)').hide();
  $('#recent-lookup-last-li').click(function(event) {
    event.stopPropagation();
    $('#recent-vin-content-div > li:gt(3)').show();
    $('#recent-lookup-last-li').css('display', 'none');
  });
})(isis, jQuery);

function submitFormWithVin(vin)
{
    document.getElementById('vin').value = vin;
    document.getElementById('lookup').submit();
}
